import Modal from "../../modal";
import ReactTable from "react-table";
import React from "react";
import { notificationColumns } from "../lib/notification-columns";

export const JobStatus = ({ notificationHistory, open, onOpen }) => {
    return (
        <Modal show={open} onClose={() => onOpen(false)}>
            <div className="justify-content-between">
                <h3>Status History</h3>
                <button className="button" onClick={() => onOpen(false)}>
                    Close
                </button>
            </div>
            <ReactTable style={{ minWidth: "800px" }} data={notificationHistory} columns={notificationColumns} minRows={1} showPagination={false} className="-center" />
        </Modal>
    );
};
